import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { postJson } from '@/utils/fetchOptions';

import { useAuthToken, useMutation } from '..';

interface UseDraftApproveProps {
  id: string;
  onSuccess: TypeAny;
}

export function useDraftApprove({ id, onSuccess }: UseDraftApproveProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const {
    isLoading,
    data = {},
    mutate,
    error
  } = useMutation({
    mutationKey: 'client-draft-approve',
    mutationFn: (feedback: string) =>
      postJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/client/draft/${id}/approve`,
        body: { feedback },
        token
      }).then((response: object | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      }),
    onSuccess
  });

  return {
    isLoading,
    mutate,
    error,
    data
  };
}
